import React, { useMemo, useCallback } from 'react';
import './index.scss';

import { miniGazelle } from '../../../../../helpers';
import DropdownChevron from '../DropdownChevron';
import ClosedDropdownIcon from '../DropdownChevron/ClosedDropdownIcon';

const MobileProductFilters = ({
    productFilters,
    visibleOptions,
    toggleFilterVisibility,
    filterRef,
    filterProducts,
    clearCurrentFilters,
    activeFilters,
    setActiveFilters,
    getFilteredProductFilters,
    setProductFilters,
}) => {
    const activeFiltersSet = useMemo(() => new Set(activeFilters.map(filter => filter.option)), [activeFilters]);

    const isFilterOptionChecked = useCallback(
        option => {
            return activeFiltersSet.has(option);
        },
        [activeFiltersSet]
    );

    const getActiveFilters = (filterChecked, option) => {
        if (filterChecked) {
            const newFilters = activeFilters.filter(filter => filter.option !== option.option);
            setActiveFilters(newFilters);
            setProductFilters(previousFilters =>
                getFilteredProductFilters(newFilters, previousFilters)
            );
        } else {
            setActiveFilters([...activeFilters, option]);
            setProductFilters(previousFilters =>
                getFilteredProductFilters([...activeFilters, option], previousFilters)
            );
        }
    };

    const handleClearFilters = event => {
        const button = event.currentTarget;
        clearCurrentFilters();
        setTimeout(() => {
            button.blur();
        }, 150);
    };

    const handleApplyFilters = event => {
        const button = event.currentTarget;
        filterProducts(activeFilters);
        setTimeout(() => {
            button.blur();
        }, 150);
    };

    return (
        <div className="mobile-product-filters" data-testid="mobile-product-filters">
            <div className="filter-header">Filter</div>
            {productFilters.map((filter, index) => (
                <div key={index} className="filter-section">
                    <button
                        className="filter-title"
                        onClick={() => toggleFilterVisibility(index)}
                        aria-expanded={visibleOptions[index] ? 'true' : 'false'}
                        aria-controls={`filter-options-${index}`}
                        tabIndex={0}
                    >
                        <span>{miniGazelle.label(filter.attributeId, true)}</span>
                        <span className={`filter-toggle-icon ${visibleOptions[index] ? 'open' : ''}`}>
                            {visibleOptions[index] ? <DropdownChevron /> : <ClosedDropdownIcon />}
                        </span>
                    </button>
                    <div
                        id={`filter-options-${index}`}
                        data-testid={`filter-options-${index}`}
                        ref={el => (filterRef.current[index] = el)}
                        className={`filter-option-dropdown ${visibleOptions[index] ? 'show' : ''}`}
                        tabIndex={-1}
                    >
                        {filter.options.map((option, i) => (
                            <label key={i} className="filter-option">
                                <input
                                    type="checkbox"
                                    tabIndex={visibleOptions[index] ? 0 : -1}
                                    checked={isFilterOptionChecked(option)}
                                    onChange={() =>
                                        getActiveFilters(isFilterOptionChecked(option), {
                                            option,
                                            name: filter.filterKey,
                                        })
                                    }
                                />
                                {option}
                            </label>
                        ))}
                    </div>
                </div>
            ))}
            <div className="button-container">
                <button className="clear-button" onClick={handleClearFilters}>
                    Clear all
                </button>
                <button className="apply-button" onClick={handleApplyFilters}>
                    Apply
                </button>
            </div>
        </div>
    );
};

export default MobileProductFilters;
